// Persistent zustand store for the paired helper credentials.
//
// We persist `port`, `bearer`, `csrfToken`, `pairedAt`, and `deviceName` to
// localStorage so a page refresh doesn't require re-pairing. The bearer is
// scoped to localhost-only origin checks on the helper side; storing it in
// localStorage matches the threat model in ADR-017 (browser-tier secret,
// not a long-lived server credential).

import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface HelperCredentials {
  port: number;
  bearer: string;
  csrfToken: string;
  pairedAt: string;
  deviceName: string;
}

interface HelperState {
  credentials: HelperCredentials | null;
  setCredentials: (c: HelperCredentials) => void;
  clear: () => void;
}

export const useHelperStore = create<HelperState>()(
  persist(
    (set) => ({
      credentials: null,
      setCredentials: (credentials) => set({ credentials }),
      clear: () => set({ credentials: null }),
    }),
    {
      name: 'aiassist.helper.v1',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);

/** Convenience: returns `http://127.0.0.1:<port>` once paired, else null. */
export function helperBaseUrl(port: number | null | undefined): string | null {
  if (!port) return null;
  return `http://127.0.0.1:${port}`;
}
